





























import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import {
  defaultMagazineVolumeEditVolumeInfoItem,
  MagazineVolumeEditVolumeInfo,
  MagazineVolumeEditVolumeInfoItem
} from '@/components/organisms/MagazineVolumeEditVolumeInfo'
import {
  defaultMagazineVolumeEditBibliographyInfoItem,
  MagazineVolumeEditBibliographyInfo,
  MagazineVolumeEditBibliographyInfoItem
} from '@/components/organisms/MagazineVolumeEditBibliographyInfo'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  defaultSimpleMagazine,
  ErrorMessage,
  SimpleMagazine
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeALC00007 } from '@/types'

interface ModalMagazineVolumeEditInterface {
  bibliographyRealId: number
  onClickOk: () => void
}

@Component({
  components: {
    MagazineVolumeEditBibliographyInfo,
    MagazineVolumeEditVolumeInfo,
    ModalFooter
  }
})
export default class ModalMagazineVolumeEdit extends ComponentVue {
  dialog: boolean = false

  okCallback?: () => void

  simpleMagazine: SimpleMagazine = defaultSimpleMagazine()

  volumeItem: MagazineVolumeEditVolumeInfoItem = defaultMagazineVolumeEditVolumeInfoItem()

  bibliographyItem: MagazineVolumeEditBibliographyInfoItem = defaultMagazineVolumeEditBibliographyInfoItem()

  open(params: ModalMagazineVolumeEditInterface): void {
    this.getSimpleMagazine(params.bibliographyRealId)
    this.okCallback = params.onClickOk
    this.dialog = true
  }

  close(): void {
    this.simpleMagazine = defaultSimpleMagazine()
    this.volumeItem = defaultMagazineVolumeEditVolumeInfoItem()
    this.bibliographyItem = defaultMagazineVolumeEditBibliographyInfoItem()
    this.okCallback = undefined
    this.dialog = false
  }

  onClickOk(): void {
    const alert: Alert = AlertFactory.create(
      AlertCodeALC00007,
      '雑誌・巻号',
      '登録'
    )
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.updateSimpleMagazine
    })
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        'hasOwnProperty' in obj[key][alert.index][subKey] &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        'hasOwnProperty' in obj[key] &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          'hasOwnProperty' in obj[splitKeys[0]][splitKeys[1]] &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async getSimpleMagazine(bibliographyRealId: number): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.simpleMagazine = await bibliographyRealApi.getSimpleMagazine(
        bibliographyRealId
      )
      this.volumeItem = {
        volume: {
          input: this.simpleMagazine.volume,
          errorMessage: ''
        },
        volumeNumber: {
          input: this.simpleMagazine.volumeNumber,
          errorMessage: ''
        },
        volumeTotal: {
          input: this.simpleMagazine.volumeTotal,
          errorMessage: ''
        },
        dateLabel: {
          input: this.simpleMagazine.dateLabel,
          errorMessage: ''
        },
        dateIssue: {
          input: this.simpleMagazine.dateIssue,
          errorMessage: ''
        },
        specialType: {
          input: this.simpleMagazine.specialType,
          errorMessage: ''
        }
      }

      this.bibliographyItem = {
        prefix: this.simpleMagazine.prefix,
        bibliographyRealId: this.simpleMagazine.bibliographyRealId,
        materialFormat: {
          input: this.simpleMagazine.materialFormat.code,
          errorMessage: ''
        },
        continuationStatus: {
          input: this.simpleMagazine.continuationStatus.code,
          errorMessage: ''
        },
        magazineCode: {
          input: this.simpleMagazine.magazineCode,
          errorMessage: ''
        },
        classNo: {
          input: this.simpleMagazine.classNo,
          errorMessage: ''
        },
        edition: {
          input: this.simpleMagazine.edition,
          errorMessage: ''
        },
        publicationYear: {
          input: this.simpleMagazine.publicationYear,
          errorMessage: ''
        },
        price: {
          input: this.simpleMagazine.price,
          errorMessage: ''
        },
        displayPrice: {
          input: this.simpleMagazine.displayPrice,
          errorMessage: ''
        },
        size: {
          input: this.simpleMagazine.size,
          errorMessage: ''
        },
        page: {
          input: this.simpleMagazine.page,
          errorMessage: ''
        },
        imageFile: {
          input: ''
        },
        _imageFileDelete: {
          input: false
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      this.close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async updateSimpleMagazine(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await bibliographyRealApi.updateSimpleMagazine({
        id: this.simpleMagazine.bibliographyRealId,
        volume: this.volumeItem.volume.input,
        volumeNumber: this.volumeItem.volumeNumber.input,
        volumeTotal: this.volumeItem.volumeTotal.input,
        dateLabel: this.volumeItem.dateLabel.input,
        dateIssue: this.volumeItem.dateIssue.input,
        specialType: this.volumeItem.specialType.input,
        materialFormat: this.bibliographyItem.materialFormat.input,
        continuationStatus: this.bibliographyItem.continuationStatus.input,
        magazineCode: this.bibliographyItem.magazineCode.input,
        classNo: this.bibliographyItem.classNo.input,
        edition: this.bibliographyItem.edition.input,
        publicationYear: this.bibliographyItem.publicationYear.input,
        price: this.bibliographyItem.price.input,
        displayPrice: this.bibliographyItem.displayPrice.input,
        size: this.bibliographyItem.size.input,
        page: this.bibliographyItem.page.input,
        imageFile: this.bibliographyItem.imageFile.input,
        _imageFileDelete: this.bibliographyItem._imageFileDelete.input,
        revision: this.simpleMagazine.revision
      })

      if (this.okCallback) {
        this.okCallback()
      }
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, {
          volume: this.volumeItem.volume,
          volumeNumber: this.volumeItem.volumeNumber,
          volumeTotal: this.volumeItem.volumeTotal,
          dateLabel: this.volumeItem.dateLabel,
          dateIssue: this.volumeItem.dateIssue,
          specialType: this.volumeItem.specialType,
          materialFormat: this.bibliographyItem.materialFormat,
          continuationStatus: this.bibliographyItem.continuationStatus,
          magazineCode: this.bibliographyItem.magazineCode,
          classNo: this.bibliographyItem.classNo,
          edition: this.bibliographyItem.edition,
          publicationYear: this.bibliographyItem.publicationYear,
          price: this.bibliographyItem.price,
          displayPrice: this.bibliographyItem.displayPrice,
          size: this.bibliographyItem.size,
          page: this.bibliographyItem.page
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
